module.exports = __webpack_public_path__ + "images/mantel_small1c87ff45f8f8c3e940d278d10716ceae.png";